<!-- 内容列表 -->
<template>
<div class='collect'>
  <span @click='handleClose' class="close">x</span>
  <div class="empty" v-if="list.length === 0">暂无数据</div>
  <div v-for="(item, index) in list" :key='item.id' class="items">
    <div v-if="item.isCollected">
      <div class="item" @click='handleSelected(index, item.id, item.name)'>
        <div class="type">表格</div>
        <div  :class="['article', {'borderBtm': index === listData.length - 1 }]">
          <div :class="['name', {'ischeck': item.ischeck}]">{{item.name}}</div>
          <span :class="['icon', {'collected': item.isCollected}]"></span>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import api from '@edu-fe/api'
export default {
  components: {},
  data() {
    return {
      mediaData: '',
      list: [],
    };
  },
  props: {
    listData: Array,
    handleSelectedPlay: Function,
  },
  computed: {},
  watch: {},
  methods: {
    handleClose() {
      this.$emit('changeCollect')
    },
    handleSelected (item, id, name) {
      this.list.map((ele,index) => {
        Vue.set(ele, 'ischeck', false)
      })
      Vue.set(this.list[item], 'ischeck', true)
      this.$emit('handleSelectedPlay', id, name)
    },
    initListData() {
      this.listData && this.listData.map((ele,index)=>{
        if(ele.isCollected) {
          this.list.push(ele)
        }
      })
    }
  },
  created() {
  },
  mounted() {
    this.initListData()
  },
}
</script>
<style lang='scss' scoped>
@charset "UTF-8";

@import "../../../style/main";

.collect {
  width:rem(622);
  height: rem(650);
  overflow: auto;
  margin-top: rem(40);
  // padding-bottom: rem(130);
  background:rgba(255,255,255,1);
  box-shadow:rem(0) rem(8) rem(25) rem(0) rgba(51,51,51,0.2);
  border-radius:rem(12);
  // padding-top: rem(100);
  padding: rem(100) rem(32) rem(130) rem(32);
  position: relative;
  .close {
    position: absolute;
    top: rem(29);
    right: rem(29);
    width: rem(41);
    height: rem(41);
    text-align: center;
    line-height: rem(41);
    font-size: rem(36);
    color: #999999;
  }
  .empty {
    padding-top: rem(115);
    text-align: center;
    border-top: rem(1) solid rgba(153,153,153,.4);
  }
  .items {
    .item {
      width: 100%;
      height: rem(124);
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-top: rem(1) solid rgba(153,153,153,.4);
      .type {
        width: rem(100);
        height:rem(50);
        background:rgba(242,255,244,1);
        border-radius:rem(8);
        border:rem(1) solid #6BD660;
        text-align: center;
        line-height: rem(50);
        color: #4BCC5A;
        // border-image:linear-gradient(135deg, rgba(107,214,96,1), rgba(66,202,89,1)) 1 1;
      }
      .date {
        width: rem(72);
        height: rem(72);
        background:rgba(153,153,153,0.1);
        border-radius:rem(6);
        border:rem(1) solid rgba(153,153,153,0.3);
        text-align: center;
        font-size: rem(28);
        font-weight:500;
        color: #999;
        line-height:rem(36);
        .month {
          display: block;
          border-bottom: 1px solid rgba(153,153,153,.4);
        }
        .day {
          color: #666;
          font-size: rem(34);
        }
      }
      .ischeckDate {
        background: #FB5B24;
        color: #fff !important;
        .month {
          border-bottom: 1px solid #fff !important;
        }
        .day {
          color: #fff !important;
        }
      }
      .ischeckbg {
        background: #FB5B24;
        color:rgba(255,255,255,1);
      }
      .borderBtm {
        border: none !important;
      }
      .article {
        // flex: 1;
        width: rem(520);
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .name {
          margin-left: rem(33);
          width:rem(450);
          font-size:rem(30);
          font-weight:400;
          color:#333;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
        }
        .icon {
          width:rem(32);
          height:rem(32);
          display: block;
          background:url('../../../assets/icons/diversion_collect_normal.png') no-repeat right center;
          background-size: rem(32) rem(32);
          padding: rem(30) 0 rem(30) rem(30);
          z-index: 999;
        }
        .collected {
          background:url('../../../assets/icons/diversion_collect_selected.png') no-repeat right center;
          background-size: rem(32) rem(32);
        }
        .ischeck {
          color: #4BCC5A
        }
      }
    }
  }
}
//@import url(); 引入公共css类

</style>